/**
 * Extracts node objects from GraphQL Relay connection edges, filtering out null values.
 * @param {object} root0 - The destructured parameter object
 * @param {Array<object>} root0.edges - Array of edge objects from a GraphQL Relay connection.
 *   Each edge should have a `node` property containing the actual data object.
 * @returns {Array<object>} Array of non-null node objects extracted from the edges.
 */
const getNodesFromEdges = ({ edges }) => edges.map((el) => (el.node)).filter((el) => !!el);

export default getNodesFromEdges;
